module.exports = __webpack_public_path__ + "img/25.c29bea0e.png";